import {Button} from '@/components/atoms'
import {useNavigate} from 'react-router-dom'
import {ROUTES} from '@/utils/constants/routesConstants'

export const Actions = () => {
  const navigate = useNavigate()

  const handleCreateTier = () => {
    navigate(ROUTES.CREATE_TIER)
  }

  return (
    <section className="flex justify-between py-4">
      <Button
        uiSchema={{title: 'Reset all', variant: 'tertiaryInverse', size: 'medium', disabled: true, isDark: true}}
      />
      <section className="align-center flex gap-3">
        <Button uiSchema={{title: 'Refresh', disabled: true, variant: 'secondaryInverse', size: 'medium'}} />
        <Button handleButton={handleCreateTier} uiSchema={{title: 'Create Tier', isDark: true, size: 'medium'}} />
      </section>
    </section>
  )
}
